import script from "./pingyaoOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./pingyaoOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./pingyaoOrderRecord.vue?vue&type=style&index=0&id=f69dff14&lang=scss"

const __exports__ = script;

export default __exports__